var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"mainAlert"},[(_vm.wrongBrowser)?_c('el-alert',{attrs:{"title":"Ваш браузер не поддерживется.","type":"warning"}}):_vm._e()],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }